import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=6ec0efe8&scoped=true&lang=pug"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=6ec0efe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0efe8",
  null
  
)

export default component.exports